export default "__VITE_ASSET__DpAsrWIG__"